// extracted by mini-css-extract-plugin
export default {"block":"Block_block__J4Fcd","image":"Block_image__SfW0P","texts":"Block_texts__iK1Iz","title":"Block_title__wZJDJ","article":"Block_article__ElL0c"};